import React, { useCallback } from 'react';
import * as Styles from './ButtonCreateSiteAi.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import useLocale from '@/hooks/useLocale';
import { useHistory } from 'react-router';
import IconShapedStars from '../../Icons/IconShapedStars/IconShapedStars';
import { studioAnalytics } from '@/analytics/studio';

const ButtonCreateSiteAi = ({ position }) => {
  const history = useHistory();
  const { routes, studio: studioLocale } = useLocale();

  const studioAnalyticsEvents = (position) => {
    switch (position) {
      case 'top':
        return studioAnalytics.createSiteTopClick();
      case 'bottom':
        return studioAnalytics.createSiteBottomClick();
      default:
        return null;
    }
  };

  const handleOnClick = useCallback(() => () => {
    studioAnalyticsEvents(position);
    history.push(`${routes.sitesPage}${routes.sitesCreate}`);
  }, [history, routes.sitesPage, routes.sitesCreate, position]);

  return (
    <Styles.WrapperLinkButton data-testid="button-create-site-ai">
      <Styles.ButtonSiteCreator onClick={handleOnClick()}>
        <IconShapedStars />
        <Styles.TitleButton>{studioLocale.buttonCreateSiteAi.label}</Styles.TitleButton>
      </Styles.ButtonSiteCreator>
    </Styles.WrapperLinkButton>
  );
};

export default withErrorBoundary(ButtonCreateSiteAi, 'ButtonCreateSiteAi');
